import Axios from "axios";
import { ResourceGenerator } from "@swan/api";

const Service = ResourceGenerator(Axios, "analytics/charts", 0);

export default Service;
